import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ManningAgencyAdminService } from '../../../core/manning-agency-admin.service';

@Component({
  selector: 'app-manning-agency-rejected',
  templateUrl: './manning-agency-rejected.component.html',
  styleUrls: ['./manning-agency-rejected.component.css']
})
export class ManningAgencyRejectedComponent implements OnInit {
  private size = 5;
  token;
  manning_agencies = [];
  total = 0;
  pageNum = 1;
  pagination = [];

  constructor(
    private cookieService: CookieService,
    private manningAgencyService: ManningAgencyAdminService
  ) { }

  ngOnInit() {
    this.token = this.cookieService.get('token');
    this.manningAgencyService.getMA(this.token, 'rejected')
      .subscribe(response => {
        if (response && response.success) {
          this.manning_agencies = response.data.items;
          this.total = response.data.total;
          this.pagination = new Array(Math.ceil(this.total / this.size));
        }
      });
  }

  updatePaginate(num) {
    this.pageNum = num < 1 ? this.pageNum
      : num > this.pagination.length
      ? this.pagination.length : num;
    this.manningAgencyService.getMA(this.token, 'approved', this.pageNum)
      .subscribe(response => {
        if (response && response.success) {
          this.manning_agencies = response.data.items;
          this.total = response.data.total;
          this.pagination = new Array(Math.ceil(this.total / this.size));
        }
      });
  }

  moveToPending(ma, idx) {
    this.manningAgencyService.updateStatus(this.token, ma.manning_agencyId, 'pending')
      .subscribe(res => {
        if (res && res.success) {
          this.manning_agencies.splice(idx, 1);
          this.total = this.total - 1;
        }
      });
  }

  delete(ma, idx) {
    this.manningAgencyService.delete(this.token, ma.manning_agencyId)
      .subscribe(res => {
        if (res && res.success) {
          this.manning_agencies.splice(idx, 1);
          this.total = this.total - 1;
        }
      });
  }
}
